import { Checkbox } from "@carbon/react";


export const View = ({ rightcontent,leftcontent}) => {
  return (
    <div>
    
        <div className="sub-email-content">
            <div className="right-content">
              {rightcontent}
            </div >
          
              <input type="checkbox" className="sub-email-checkbox"/>
            <div className="left-content" >
              {leftcontent}
            </div>  
        </div>
   
    </div>
  );
};
